export default __webpack_public_path__ + "static/media/o.31ef7286.svg";